import { Text, Box } from "@chakra-ui/react";

const BorrowerCompanySearch = ({
  searchQuery,
  filterBorrowerCompany,
  handleEntityClick,
}: {
  searchQuery: string;
  filterBorrowerCompany: any;
  handleEntityClick: any;
}) => {
  return (
    <Box mt="20px" borderBottom="1px solid #E2E2E2">
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody style={{ width: "100%" }}>
          <Text fontWeight={"600"} fontSize={"12px"} mb={"10px"}>
            Company
          </Text>
          {searchQuery ? (
            filterBorrowerCompany().length > 0 ? (
              filterBorrowerCompany().map((company: any) => (
                <>
                  <tr
                    key={company.id}
                    style={{ cursor: "pointer", marginTop: "10px" }}
                    onClick={() =>
                      handleEntityClick("companies", company.company.id)
                    }
                    onMouseOver={(e) =>
                      (e.currentTarget.style.backgroundColor = "#F9F8F8")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.backgroundColor = "white")
                    }
                  >
                    <Text color={"black"} ml={"8px"} mt={"8px"} mb={"8px"}>
                      <td style={{ fontWeight: 500, width: "100%" }}>
                        {company.company.name}
                      </td>
                    </Text>
                  </tr>
                </>
              ))
            ) : (
              <tr style={{ height: "92px" }}>
                <td>
                  <Text mt={"-15px"}>No company matched.</Text>
                </td>
              </tr>
            )
          ) : (
            <tr style={{ height: "92px" }}>
              <td>
                <Text mt={"-15px"}>Enter a search query to find company.</Text>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </Box>
  );
};

export default BorrowerCompanySearch;
